export default __webpack_public_path__ + "static/media/featured-content-bg-tl-min.85fa0ef6.png";